import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './FinalMonthlyReport.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProjects, getStates, getClients, getProject, fetchMonths, getFinalAttendanceReport } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const FinalMonthlyReport = () => {
    const [state, setState] = useState(null);
    const [district, setDistrict] = useState(0);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(null);
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        // district: false,
        month: false,
        year: false,
        project: false,
        clients: false,
    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);
    const [designationData, setDesignationData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && month && year && project;
    // Function to calculate days in a month
    // const getDaysInMonth = (monthId, year) => {
    //     const monthIndex = monthId - 1; // Convert to 0-based for Date object
    //     if (!monthId || !year) return 0;

    //     const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
    //     const monthsWith30Days = [4, 6, 9, 11];

    //     if (monthsWith31Days.includes(monthId)) {
    //         return 31;
    //     } else if (monthsWith30Days.includes(monthId)) {
    //         return 30;
    //     } else if (monthId === 2) {
    //         const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    //         return isLeapYear ? 29 : 28;
    //     }
    //     return 0;
    // };

    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);

    // Fetch months
    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             setMonthOptions(
    //                 response.data
    //                     .map(item => ({
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                     }))
    //                     .sort((a, b) => a.value - b.value)
    //             );
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, []);
    // Fetch months
    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             const now = new Date();
    //             const currentYear = now.getFullYear();
    //             const currentMonth = now.getMonth() + 1; // Jan=1
    //             const currentDate = now.getDate();
    //             const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate(); // ✅ last day of current month

    //             const months = response.data
    //                 .map(item => {
    //                     let daysInMonth;

    //                     // If it's the current month of the current year
    //                     if (year === currentYear && item.monthId === currentMonth) {
    //                         daysInMonth = currentDate;
    //                     } else {
    //                         daysInMonth = new Date(year, item.monthId, 0).getDate();
    //                     }

    //                     return {
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                         days: daysInMonth,
    //                     };
    //                 })
    //                 .sort((a, b) => a.value - b.value);

    //             let filteredMonths = months;
    //             if (year) {
    //                 if (year === currentYear) {
    //                     filteredMonths = months.filter(m => {
    //                         if (m.value < currentMonth) return true; // past months always visible
    //                         if (m.value === currentMonth) {
    //                             // ✅ Show current month only if today is the last day
    //                             return currentDate === lastDayOfCurrentMonth;
    //                         }
    //                         return false;
    //                     });
    //                 } else if (year > currentYear) {
    //                     filteredMonths = []; // future year → no months
    //                 } else {
    //                     filteredMonths = months; // past year → all months
    //                 }
    //             }
    //             setMonthOptions(filteredMonths);
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, [year]);

    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);

                    const filterData = [
                        { value: 0, label: "All Districts" },
                        ...data.filter(item => item.districtId === 39).map(item => ({
                            value: item.districtId,
                            label: item.districtName
                        }))
                    ];

                    setDistrictOptions(filterData);
                    // ✅ Set district to the default 'All Districts' option when state loads
                   // setDistrict(0);

                } catch (err) {
                    console.error('Error fetching districts:', err);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null); // Clear district if state is cleared
        }
    }, [state]);
    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                    const data = await getClients(state);
                    setClientResponse(data.map(client => ({
                        value: client.id,
                        label: client.clientName,
                    }))
                    );
                } catch (error) {
                    console.error('Error fetching states:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
                }
            };
            fetchClients();
        }
        else {
            setClients(null);
        }
    }, [state]);


    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);
    // useEffect(() => {
    //     if (!effectRan.current) {
    //         fetchProjects();
    //     }
    //     return () => {
    //         effectRan.current = true;
    //     }

    // }, [state, district, year]);  // Fetch projects when state, district, or year changes


    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        let value = selectedOption ? selectedOption.value : null;
        // Special handling for "All Districts"
        // Special handling for "All Districts"
        if (field === "district" && value === 0) {
            value = 0; // 0 = All districts (numeric, compatible with ID-based logic)
        }
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'clients':
                setClients(value);
                setProject(null);
                break;
            case 'district':
                setDistrict(value);
                // setMonth(null);
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getFinalAttendanceReport({
                stateId: state,
                districtId: district === 0 ? null : district,
                month,
                year,
                projectId: project,
            });



            // Directly set the array
            const initializedData = data.map(item => ({
                ...item,
                casualLeave: item.casualLeave || 0,
                absentDays: item.absentDays || 0,
            }));

            setAttendanceData(initializedData);
            console.log("Fetched Attendance Data:", initializedData);

        } catch (error) {
            console.error("Error fetching report data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch report data",
            }));
            alert("Failed to fetch report data. Please try again.");
        }
    };




    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);


    // const generateExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet("Monthly Attendance");

    //     // --- Setup Title and Info ---
    //     // Determine merge range based on district selection
    //     const titleMergeRange = district ? "A1:V1" : "A1:N1";
    //     worksheet.mergeCells(titleMergeRange);
    //     const titleCell = worksheet.getCell("A1");
    //     titleCell.value = "Final Attendance Report";
    //     titleCell.font = { size: 16, bold: true };
    //     titleCell.alignment = { vertical: "middle", horizontal: "center" };

    //     const now = new Date();
    //     const dd = String(now.getDate()).padStart(2, "0");
    //     const mm = String(now.getMonth() + 1).padStart(2, "0");
    //     const yyyy = now.getFullYear();
    //     const reportDateTime = `${dd}-${mm}-${yyyy}`;

    //     worksheet.mergeCells("K3");
    //     worksheet.getCell("K3").value = "Report Date";
    //     worksheet.getCell("K3").font = { bold: true };
    //     worksheet.getCell("K3").alignment = { horizontal: "right" };

    //     worksheet.mergeCells("L3");
    //     worksheet.getCell("L3").value = reportDateTime;
    //     worksheet.getCell("L3").alignment = { horizontal: "center" };

    //     worksheet.addRow([]);

    //     const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "N/A";
    //     const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "N/A";
    //     const monthLabel = monthOptions.find(opt => opt.value === month)?.label || "N/A";
    //     const projectLabel = projectResponse.find(opt => opt.value === project)?.label || "N/A";
    //     const clientLabel = clientResponse.find(opt => opt.value === clients)?.label || "N/A";
    //     const monthNumber = Number(month) || now.getMonth() + 1;
    //     const yearNumber = Number(year) || now.getFullYear();
    //     const daysInMonth = new Date(yearNumber, monthNumber, 0).getDate();

    //     // State, Client, Project info
    //     worksheet.mergeCells("K5:L5");
    //     worksheet.getCell("K5").value = "State: " + stateLabel;
    //     worksheet.mergeCells("K6:L6");
    //     worksheet.getCell("K6").value = "District: " + districtLabel;
    //     worksheet.mergeCells("K7:L7");
    //     worksheet.getCell("K7").value = "Client: " + clientLabel;
    //     worksheet.mergeCells("K8:L8");
    //     worksheet.getCell("K8").value = "Project: " + projectLabel;

    //     // --- Month, Year, Days (Dynamic Rich Text with Bold Black Values) ---
    //     worksheet.mergeCells("A8:J8");
    //     worksheet.getCell("A8").value = {
    //         richText: [
    //             { text: "Month: ", font: { bold: false, color: { argb: "000000" } } },
    //             { text: `${monthLabel}  `, font: { bold: true, color: { argb: "000000" } } }, // black bold
    //             { text: "Year: ", font: { bold: false, color: { argb: "000000" } } },
    //             { text: `${year || "N/A"}  `, font: { bold: true, color: { argb: "000000" } } }, // black bold
    //             { text: "| No. of Days in Month: ", font: { bold: false, color: { argb: "000000" } } },
    //             { text: `${daysInMonth}`, font: { bold: true, color: { argb: "000000" } } }, // black bold
    //         ],
    //     };
    //     worksheet.getCell("A8").alignment = { horizontal: "left", vertical: "middle" };

    //     // --- Header Rows ---
    //     let headerRow1 = ["S.No", "District Name"];
    //     let headerRow2 = ["", ""];

    //     let metrics = ["No of Days Worked", "Total Days in Month", "No of Days Absent", "No of Employee"];
    //     let categories = district ? ["PM", "DC", "APM", "Help Desk", "Call Center"] : ["ITM", "CRO", "DEO"];

    //     // Build header rows
    //     metrics.forEach(metric => {
    //         headerRow1.push(metric);
    //         for (let i = 1; i < categories.length; i++) headerRow1.push(""); // empty cells for merge
    //         categories.forEach(cat => headerRow2.push(cat));
    //     });

    //     worksheet.addRow(headerRow1); // Row 9
    //     worksheet.addRow(headerRow2); // Row 10
    //     const thinBorder = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };

    //     // --- Row 9 Styling (Metrics) ---
    //     const row9 = worksheet.getRow(9);
    //     const metricColors = ["FFFFD1DA", "FFC1DFFF", "FFC3FCE9", "FFF4FFCE"]; // Pink, Green, Yellow, Orange

    //     // Merge Row 9 metric cells dynamically
    //     let colIndex = 3;
    //     metrics.forEach((metric, i) => {
    //         const startCol = colIndex;
    //         const endCol = startCol + categories.length - 1;

    //         // Merge metric cells
    //         worksheet.mergeCells(9, startCol, 9, endCol);

    //         // Apply background color, bold, center, border
    //         for (let col = startCol; col <= endCol; col++) {
    //             const cell = row9.getCell(col);
    //             cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: metricColors[i] } };
    //             cell.font = { bold: true };
    //             cell.alignment = { horizontal: "center", vertical: "middle" };
    //             cell.border = thinBorder;
    //         }

    //         colIndex += categories.length;
    //     });

    //     // S.No & District styling for Row 9
    //     [1, 2].forEach(c => {
    //         const cell = row9.getCell(c);
    //         cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } }; // Dark Blue
    //         cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    //         cell.alignment = { horizontal: "center", vertical: "middle" };
    //         cell.border = thinBorder;
    //     });

    //     // --- Row 10 Styling (Header Categories) ---
    //     const row10 = worksheet.getRow(10);
    //     //const thinBorder = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };

    //     // Colors: Pink, Green, Yellow, Orange
    //     const colors = ["FFFFD1DA", "FFC1DFFF", "FFC3FCE9", "FFF4FFCE"];

    //     metrics.forEach((_, i) => {
    //         const startCol = 3 + i * categories.length;
    //         const endCol = startCol + categories.length - 1;
    //         for (let col = startCol; col <= endCol; col++) {
    //             const cell = row10.getCell(col);
    //             cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors[i] } };
    //             cell.font = { bold: true };
    //             cell.alignment = { horizontal: "center", vertical: "middle" };
    //             cell.border = thinBorder;
    //         }
    //     });

    //     // S.No & District styling
    //     [1, 2].forEach(c => {
    //         const cell = row10.getCell(c);
    //         cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } }; // Dark Blue
    //         cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    //         cell.alignment = { horizontal: "center", vertical: "middle" };
    //         cell.border = thinBorder;
    //     });
    //     // --- Increase Column Widths ---
    //     worksheet.columns = [
    //         { width: 6 },   // S.No
    //         { width: 25 },  // District Name
    //         // Categories dynamically
    //         ...Array(categories.length * metrics.length).fill({ width: 12 }),
    //     ];
    //     // --- Body Rows ---
    //     const v = val => (val !== null && val !== undefined && val !== "") ? val : "-";

    //     let bodyFields = district
    //         ? ["pmWorked", "pmdcWorked", "apmWorked", ("hdoWorked", "hdopWorked"), "ccoWorked", "pmTotal", "pmdcTotal", "apmTotal", ("hdoTotal", "hdopTotal"), "ccoTotal", "pmAbsent", "pmdcAbsent", "apmAbsent", ("hdoAbsent", "hdopAbsent"), "ccoAbsent", "totalPmEmployees", "totalPmdcEmployees", "totalApmEmployees", ("totalHdoEmployees", "totalHdopEmployees"), "totalCcoEmployees"]
    //         : ["itmWorked", "croWorked", "deoWorked", "itmTotal", "croTotal", "deoTotal", "itmAbsent", "croAbsent", "deoAbsent", "totalItmEmployees", "totalCroEmployees", "totalDeoEmployees"];

    //     attendanceData.forEach((row, index) => {
    //         let rowData = [index + 1, row.districtName];
    //         bodyFields.forEach(field => rowData.push(v(row[field])));
    //         worksheet.addRow(rowData);
    //     });

    //     // --- Total Row ---
    //     const calcTotal = field => attendanceData.reduce((sum, r) => sum + (Number(r[field]) || 0), 0);
    //     const calcHDO = (f1, f2) => attendanceData.reduce((sum, r) => sum + (Number(r[f1]) || 0) + (Number(r[f2]) || 0), 0);

    //     let totalRowData = ["Total", ""];
    //     if (district) {
    //         totalRowData.push(
    //             calcTotal("pmWorked"), calcTotal("pmdcWorked"), calcTotal("apmWorked"), calcHDO("hdoWorked", "hdopWorked"), calcTotal("ccoWorked"),
    //             calcTotal("pmTotal"), calcTotal("pmdcTotal"), calcTotal("apmTotal"), calcHDO("hdoTotal", "hdopTotal"), calcTotal("ccoTotal"),
    //             calcTotal("pmAbsent"), calcTotal("pmdcAbsent"), calcTotal("apmAbsent"), calcHDO("hdoAbsent", "hdopAbsent"), calcTotal("ccoAbsent"),
    //             calcTotal("totalPmEmployees"), calcTotal("totalPmdcEmployees"), calcTotal("totalApmEmployees"), calcHDO("totalHdoEmployees", "totalHdopEmployees"), calcTotal("totalCcoEmployees")
    //         );
    //     } else {
    //         bodyFields.forEach(f => totalRowData.push(calcTotal(f)));
    //     }

    //     const totalRow = worksheet.addRow(totalRowData);
    //     totalRow.font = { bold: true };
    //     totalRow.eachCell(cell => {
    //         cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } };
    //         cell.border = thinBorder;
    //     });

    //     // --- Download File ---
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], { type: "application/octet-stream" });
    //     const link = document.createElement("a");
    //     link.href = URL.createObjectURL(blob);
    //     link.download = `Final_Monthly_Attendance_${month}_${year}.xlsx`;
    //     link.click();
    // };


    const generateExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Monthly Attendance");

        // --- Setup Title and Info ---
        const titleMergeRange = district ? "A1:V1" : "A1:N1";
        worksheet.mergeCells(titleMergeRange);
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Final Attendance Report";
        titleCell.font = { size: 16, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const yyyy = now.getFullYear();
        const reportDateTime = `${dd}-${mm}-${yyyy}`;

        worksheet.mergeCells("K3");
        worksheet.getCell("K3").value = "Report Date";
        worksheet.getCell("K3").font = { bold: true };
        worksheet.getCell("K3").alignment = { horizontal: "right" };

        worksheet.mergeCells("L3");
        worksheet.getCell("L3").value = reportDateTime;
        worksheet.getCell("L3").alignment = { horizontal: "center" };

        worksheet.addRow([]);

        const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "N/A";
        const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "N/A";
        const monthLabel = monthOptions.find(opt => opt.value === month)?.label || "N/A";
        const projectLabel = projectResponse.find(opt => opt.value === project)?.label || "N/A";
        const clientLabel = clientResponse.find(opt => opt.value === clients)?.label || "N/A";

        const monthNumber = Number(month) || now.getMonth() + 1;
        const yearNumber = Number(year) || now.getFullYear();
        const daysInMonth = new Date(yearNumber, monthNumber, 0).getDate();

        // --- Header Info ---
        worksheet.mergeCells("K5:L5");
        worksheet.getCell("K5").value = "State: " + stateLabel;
        worksheet.mergeCells("K6:L6");
        worksheet.getCell("K6").value = "District: " + districtLabel;
        worksheet.mergeCells("K7:L7");
        worksheet.getCell("K7").value = "Client: " + clientLabel;
        worksheet.mergeCells("K8:L8");
        worksheet.getCell("K8").value = "Project: " + projectLabel;

        worksheet.mergeCells("A8:J8");
        worksheet.getCell("A8").value = {
            richText: [
                { text: "Month: ", font: { bold: false, color: { argb: "000000" } } },
                { text: `${monthLabel}  `, font: { bold: true, color: { argb: "000000" } } },
                { text: "Year: ", font: { bold: false, color: { argb: "000000" } } },
                { text: `${year || "N/A"}  `, font: { bold: true, color: { argb: "000000" } } },
                { text: "| No. of Days in Month: ", font: { bold: false, color: { argb: "000000" } } },
                { text: `${daysInMonth}`, font: { bold: true, color: { argb: "000000" } } },
            ],
        };
        worksheet.getCell("A8").alignment = { horizontal: "left", vertical: "middle" };

        // --- Header Rows ---
        let headerRow1 = ["S.No", "District Name"];
        let headerRow2 = ["", ""];

        let metrics = ["No of Days Worked", "Total Days in Month", "No of Days Absent", "No of Employee"];
        let isCMR = project === "CMR" || project === "2";
        let isEPDS = project === "ePds" || project === "1";

        // --- Dynamic Help Desk Label ---
        let helpDeskLabel = isCMR ? "Help Desk (HDOP)" : "Help Desk (HDO)";

        let categories = district
            ? ["PM", "DC", "APM", helpDeskLabel, "Call Center"]
            : ["ITM", "CRO", "DEO"];

        metrics.forEach(metric => {
            headerRow1.push(metric);
            for (let i = 1; i < categories.length; i++) headerRow1.push("");
            categories.forEach(cat => headerRow2.push(cat));
        });

        worksheet.addRow(headerRow1); // Row 9
        worksheet.addRow(headerRow2); // Row 10

        const thinBorder = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
        const row9 = worksheet.getRow(9);
        const metricColors = ["FFFFD1DA", "FFC1DFFF", "FFC3FCE9", "FFF4FFCE"];

        // --- Merge & Style Row 9 ---
        let colIndex = 3;
        metrics.forEach((metric, i) => {
            const startCol = colIndex;
            const endCol = startCol + categories.length - 1;
            worksheet.mergeCells(9, startCol, 9, endCol);
            for (let col = startCol; col <= endCol; col++) {
                const cell = row9.getCell(col);
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: metricColors[i] } };
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = thinBorder;
            }
            colIndex += categories.length;
        });

        [1, 2].forEach(c => {
            const cell = row9.getCell(c);
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.border = thinBorder;
        });

        // --- Row 10 Styling ---
        const row10 = worksheet.getRow(10);
        const colors = ["FFFFD1DA", "FFC1DFFF", "FFC3FCE9", "FFF4FFCE"];
        metrics.forEach((_, i) => {
            const startCol = 3 + i * categories.length;
            const endCol = startCol + categories.length - 1;
            for (let col = startCol; col <= endCol; col++) {
                const cell = row10.getCell(col);
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors[i] } };
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = thinBorder;
            }
        });

        [1, 2].forEach(c => {
            const cell = row10.getCell(c);
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.border = thinBorder;
        });

        // --- Column Widths ---
        worksheet.columns = [
            { width: 6 },
            { width: 25 },
            ...Array(categories.length * metrics.length).fill({ width: 12 }),
        ];

        // --- Body Rows ---
        const v = val => (val !== null && val !== undefined && val !== "") ? val : "-";

        // ✅ Define Body Fields with safe default
        let bodyFields = [];

        if (district) {
            const sample = attendanceData[0] || {};
            const hasHdopData = sample.hdopWorked > 0;
            const hasHdoData = sample.hdoWorked > 0;

            console.log("attendanceData sample:", sample);
            console.log("Detected hasHdopData:", hasHdopData, "hasHdoData:", hasHdoData);

            if (hasHdopData) {
                // CMR
                bodyFields = [
                    "pmWorked", "pmdcWorked", "apmWorked", "hdopWorked", "ccoWorked",
                    "pmTotal", "pmdcTotal", "apmTotal", "hdopTotal", "ccoTotal",
                    "pmAbsent", "pmdcAbsent", "apmAbsent", "hdopAbsent", "ccoAbsent",
                    "totalPmEmployees", "totalPmdcEmployees", "totalApmEmployees",
                    "totalHdopEmployees", "totalCcoEmployees"
                ];
                console.log("Using hdop fields for CMR:", bodyFields);
            } else if (hasHdoData) {
                // ePDS
                bodyFields = [
                    "pmWorked", "pmdcWorked", "apmWorked", "hdoWorked", "ccoWorked",
                    "pmTotal", "pmdcTotal", "apmTotal", "hdoTotal", "ccoTotal",
                    "pmAbsent", "pmdcAbsent", "apmAbsent", "hdoAbsent", "ccoAbsent",
                    "totalPmEmployees", "totalPmdcEmployees", "totalApmEmployees",
                    "totalHdoEmployees", "totalCcoEmployees"
                ];
                console.log("Using hdo fields for ePDS:", bodyFields);
            } else {
                console.warn("No data for hdop or hdo found. Falling back to default fields.");
                bodyFields = [
                    "pmWorked", "pmdcWorked", "apmWorked", "ccoWorked",
                    "pmTotal", "pmdcTotal", "apmTotal", "ccoTotal",
                    "pmAbsent", "pmdcAbsent", "apmAbsent", "ccoAbsent",
                    "totalPmEmployees", "totalPmdcEmployees", "totalApmEmployees", "totalCcoEmployees"
                ];
            }
        } else {
            bodyFields = [
                "itmWorked", "croWorked", "deoWorked",
                "itmTotal", "croTotal", "deoTotal",
                "itmAbsent", "croAbsent", "deoAbsent",
                "totalItmEmployees", "totalCroEmployees", "totalDeoEmployees"
            ];
            console.log("Non-district fields:", bodyFields);
        }


        // ✅ Prevent runtime crash if attendanceData is missing
        if (!attendanceData || !Array.isArray(attendanceData) || attendanceData.length === 0) {
            console.error("attendanceData is missing or invalid:", attendanceData);
            alert("No attendance data found to generate Excel!");
            return;
        }

        attendanceData.forEach((row, index) => {
            let rowData = [index + 1, row.districtName || "-"];
            bodyFields.forEach(field => rowData.push(v(row[field])));
            worksheet.addRow(rowData);
        });

        // --- Totals Row ---
        const calcTotal = field => attendanceData.reduce((sum, r) => sum + (Number(r[field]) || 0), 0);
        const calcHDO = (f1, f2) => attendanceData.reduce((sum, r) => sum + (Number(r[f1]) || 0) + (Number(r[f2]) || 0), 0);

        let totalRowData = ["Total", ""];
        if (district) {
            totalRowData.push(
                calcTotal("pmWorked"), calcTotal("pmdcWorked"), calcTotal("apmWorked"), calcHDO("hdoWorked", "hdopWorked"), calcTotal("ccoWorked"),
                calcTotal("pmTotal"), calcTotal("pmdcTotal"), calcTotal("apmTotal"), calcHDO("hdoTotal", "hdopTotal"), calcTotal("ccoTotal"),
                calcTotal("pmAbsent"), calcTotal("pmdcAbsent"), calcTotal("apmAbsent"), calcHDO("hdoAbsent", "hdopAbsent"), calcTotal("ccoAbsent"),
                calcTotal("totalPmEmployees"), calcTotal("totalPmdcEmployees"), calcTotal("totalApmEmployees"), calcHDO("totalHdoEmployees", "totalHdopEmployees"), calcTotal("totalCcoEmployees")
            );
        } else {
            bodyFields.forEach(f => totalRowData.push(calcTotal(f)));
        }

        const totalRow = worksheet.addRow(totalRowData);
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } };
            cell.border = thinBorder;
        });

        // --- Download File ---
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Final_Monthly_Attendance_${month}_${year}.xlsx`;
        link.click();
    };




    return (
        <div className="fina-report-container">
            <div className="fina-report-box">
                <h2 className="fina-report-heading">Final Attendance Report</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="fina-report-maincontainer">
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="fina-report-container-part">
                            <div className="fina-report-container-part">
                                <div className={`fina-report-floating-label-container ${isFocused.district || district !== null ? 'float-label' : ''}`}>
                                    <Select
                                        // ... (other Select props)
                                        name="district"
                                        options={districtOptions}
                                        // value comparison remains correct
                                        value={districtOptions.find(opt => opt.value === district) || null}
                                        onChange={option => handleInputChange(option, 'district')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>Working District</label>
                                    {errors.district && <div className="error-message">{errors.district}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="fina-report-maincontainer">
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="fina-report-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="fina-report-maincontainer">
                        <div className="epf-esic-updation-container-part">
                            <div className={`epf-esic-updation-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={clientResponse}
                                    value={clientResponse.find(opt => opt.value === clients) || null}
                                    onChange={option => handleInputChange(option, 'clients')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Client</label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>

                        </div>
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>
                                    <span className="required">*</span>Project
                                </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>

                    </div>
                    <div className="fina-report-btn-div">
                        <button type="submit" className="fina-report-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Generate Report
                        </button>
                    </div>
                </form>
            </div>
            <div className="fina-report-btn-div">
                <button
                    type="button"
                    className="fina-report-btn"
                    onClick={generateExcel}
                    disabled={attendanceData.length === 0}  // ✅ disabled if no data
                >
                    Download Excel
                </button>
                {/* <button
                    type="button"
                    className="fina-report-btn"
                    onClick={generatePDF}
                    disabled={attendanceData.length === 0}  // ✅ disabled if no data
                >
                    Download PDF
                </button> */}
            </div>

            <div className="final-table">
                {district ? (
                    <div className='final-mid-table'>

                        <table className="final-report">

                            <thead>
                                <tr>
                                    <th rowSpan={2}>S.No</th>
                                    <th rowSpan={2}>District Name</th>
                                    <th colSpan={5}>No of Days Worked</th>
                                    <th colSpan={5}>Total Days in Month</th>
                                    <th colSpan={5}>No of Days Absent</th>
                                    <th colSpan={5}>No of Employee</th>
                                </tr>
                                <tr>

                                    <th className='noof-working-days-color-header'>PM</th>
                                    <th className='noof-working-days-color-header'>DC</th>
                                    <th className='noof-working-days-color-header'>APM</th>
                                    <th className='noof-working-days-color-header'>Help Desk</th>
                                    <th className='noof-working-days-color-header'>Call Center</th>

                                    <th className='total-days-inmon-color-header'>PM</th>
                                    <th className='total-days-inmon-color-header'>DC</th>
                                    <th className='total-days-inmon-color-header'>APM</th>
                                    <th className='total-days-inmon-color-header'>Help Desk</th>
                                    <th className='total-days-inmon-color-header'>Call Center</th>

                                    <th className='noof-days-absent-color-header'>PM</th>
                                    <th className='noof-days-absent-color-header'>DC</th>
                                    <th className='noof-days-absent-color-header'>APM</th>
                                    <th className='noof-days-absent-color-header'>Help Desk</th>
                                    <th className='noof-days-absent-color-header'>Call Center</th>

                                    <th className='noof-emp-color-header'>PM</th>
                                    <th className='noof-emp-color-header'>DC</th>
                                    <th className='noof-emp-color-header'>APM</th>
                                    <th className='noof-emp-color-header'>Help Desk</th>
                                    <th className='noof-emp-color-header'>Call Center</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attendanceData.length > 0 ? (
                                    <>
                                        {/* Total Row */}
                                        <tr style={{ fontWeight: "bold", backgroundColor: "#whitesmoke" }}>
                                            <td colSpan={2}>Total</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmdcWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.apmWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.hdoWorked || 0) + (r.hdopWorked || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.ccoWorked || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmdcTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.apmTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.hdoTotal || 0) + (r.hdopTotal || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.ccoTotal || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmdcAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.apmAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.hdoAbsent || 0) + (r.hdopAbsent || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.ccoAbsent || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalPmEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalPmdcEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalApmEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.totalHdoEmployees || 0) + (r.totalHdopEmployees || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalCcoEmployees || 0), 0)}</td>
                                        </tr>

                                        {attendanceData.map((row, index) => (
                                            <tr key={row.districtName + index}>
                                                <td>{index + 1}</td>
                                                <td>{row.districtName}</td>

                                                <td>{row.pmWorked || '-'}</td>
                                                <td>{row.pmdcWorked || '-'}</td>
                                                <td>{row.apmWorked || '-'}</td>
                                                <td>{row.hdoWorked || row.hdopWorked || '-'}</td>
                                                <td>{row.ccoWorked || '-'}</td>

                                                <td>{row.pmTotal || '-'}</td>
                                                <td>{row.pmdcTotal || '-'}</td>
                                                <td>{row.apmTotal || '-'}</td>
                                                <td>{row.hdoTotal || row.hdopTotal || '-'}</td>
                                                <td>{row.ccoTotal || '-'}</td>

                                                <td>{row.pmAbsent || '-'}</td>
                                                <td>{row.pmdcAbsent || '-'}</td>
                                                <td>{row.apmAbsent || '-'}</td>
                                                <td>{row.hdoAbsent || row.hdopAbsent || '-'}</td>
                                                <td>{row.ccoAbsent || '-'}</td>

                                                <td>{row.totalPmEmployees || '-'}</td>
                                                <td>{row.totalPmdcEmployees || '-'}</td>
                                                <td>{row.totalApmEmployees || '-'}</td>
                                                <td>{row.totalHdoEmployees || row.totalHdopEmployees || '-'}</td>
                                                <td>{row.totalCcoEmployees || '-'}</td>
                                            </tr>
                                        ))}
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="22" style={{ textAlign: "center", padding: "20px" }}>
                                            No attendance data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                ) : (
                    // Table when only stateId is provided
                    <div className='final-mid-table'>
                        <table className="final-report">

                            <thead>
                                <tr>
                                    <th rowSpan={2}>S.No</th>
                                    <th rowSpan={2}>District Name</th>
                                    <th colSpan={3}>No of Days Worked</th>
                                    <th colSpan={3}>Total Days in Month</th>
                                    <th colSpan={3}>No of Days Absent</th>
                                    <th colSpan={3}>No of Employee</th>
                                </tr>
                                <tr>

                                    <th className='noof-working-days-color-header' >ITM</th>
                                    <th className='noof-working-days-color-header'>CRO</th>
                                    <th className='noof-working-days-color-header'>DEO</th>

                                    <th className='total-days-inmon-color-header'>ITM</th>
                                    <th className='total-days-inmon-color-header'>CRO</th>
                                    <th className='total-days-inmon-color-header'> DEO</th>

                                    <th className='noof-days-absent-color-header'>ITM</th>
                                    <th className='noof-days-absent-color-header'>CRO</th>
                                    <th className='noof-days-absent-color-header'>DEO</th>

                                    <th className='noof-emp-color-header'>ITM</th>
                                    <th className='noof-emp-color-header'>CRO</th>
                                    <th className='noof-emp-color-header'>DEO</th>

                                </tr>

                            </thead>
                            <tbody>
                                {attendanceData.length > 0 ? (
                                    <>
                                        {/* ✅ Total Row */}
                                        <tr style={{ fontWeight: "bold", backgroundColor: "#whitesmoke" }}>
                                            <td colSpan={2}>Total</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.itmWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.croWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.deoWorked || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.itmTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.croTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.deoTotal || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.itmAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.croAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.deoAbsent || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalItmEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalCroEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalDeoEmployees || 0), 0)}</td>

                                        </tr>
                                        {attendanceData.map((row, index) => (
                                            <tr key={row.districtName + index}>
                                                <td>{index + 1}</td>
                                                <td>{row.districtName}</td>
                                                <td>{row.itmWorked}</td>
                                                <td>{row.croWorked}</td>
                                                <td>{row.deoWorked}</td>

                                                <td>{row.itmTotal}</td>
                                                <td>{row.croTotal}</td>
                                                <td>{row.deoTotal}</td>

                                                <td>{row.itmAbsent}</td>
                                                <td>{row.croAbsent}</td>
                                                <td>{row.deoAbsent}</td>

                                                <td>{row.totalItmEmployees}</td>
                                                <td>{row.totalCroEmployees}</td>
                                                <td>{row.totalDeoEmployees}</td>

                                            </tr>
                                        ))}


                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="14" style={{ textAlign: "center", padding: "20px" }}>
                                            No attendance data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                )}
            </div>



        </div>
    );
};

export default FinalMonthlyReport;